// Price of one additional team seat, by the owner's billing cycle. Mirrors
// the STRIPE_PRICE_SEAT_MONTHLY/ANNUAL prices in Stripe — change both together.
export const SEAT_PRICE_LABEL = {
  monthly: '$75/mo',
  annual: '$900/yr',
};

// Additional seats included free with Premium (FREE_SEAT_COUNT in
// backend/src/utils/additionalSeats.js). Standard includes none.
export const PREMIUM_INCLUDED_SEATS = 2;
